export default "__VITE_ASSET__CSjCoqA4__"